import styles from "./overlay.module.scss";
import { CardProps } from "../../types";


function Overlay({ children }: CardProps) {
  return (
    <div className={styles.overlay}>
      <div className={styles.mainContainer}>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}

export default Overlay;
